import React, {useState} from 'react';
import {isEmpty} from 'lodash';
import Label from 'shared/components/label';
import AccessibleTypeahead from 'shared/components/accessible-typeahead';
import {collegeQueryResults} from 'shared/actions/college-typeaheads';
import StateSelect from 'src/views/admin/CollegeListingCampuses/StateSelect';
import Form from 'src/views/admin/CollegeListingCampuses/form';
import {getCollege} from 'src/redux/admin/actions/communityCollegeSearch';
import {useDispatch} from 'react-redux';
import placeholders from 'src/static/placeholders.json';

interface CollegeCampus {
  _id: string;
  name: string;
  isNew?: boolean;
}

export interface CollegeCampusFormInstitution {
  _id: string | null;
  unitId: string | null;
  city: string | null;
  state: string | null;
  name: string | null;
  type: string | null;
  campuses: CollegeCampus[];
}

const CollegeCampusForm = () => {
  const dispatch = useDispatch();
  const [institution, setInstitution] = useState<CollegeCampusFormInstitution>({
    _id: null,
    unitId: '',
    city: null,
    state: null,
    name: null,
    type: null,
    campuses: [],
  });
  const [state, setState] = useState<string>('');

  const updateForm = ({college}) => {
    setInstitution({
      _id: college.id,
      unitId: college.unitId,
      name: college.name,
      city: college.city,
      state: college.state,
      type: 'CommunityCollege',
      campuses: college.campuses,
    });
  };

  return (
    <>
      <div className="cc-campus-search-section">
        <div className="content">
          <div className="search-title">Search for a community college</div>

          <StateSelect state={state} onChange={(s) => setState(s)} />

          <Label>
            Community College Name
            <AccessibleTypeahead
              id="admin-community-college-name-typeahead"
              placeholder={placeholders.communityCollege}
              value={{
                unitId: institution.unitId,
                text: institution.name || '',
              }}
              onSearch={(query) => {
                setInstitution({...institution, unitId: null, name: query});
                return collegeQueryResults(query, [], true, undefined, state);
              }}
              onInputChange={(value) => {
                setInstitution({...institution, _id: null, name: value});
              }}
              onSelect={(result) => {
                setInstitution({...institution, name: result.text});
                dispatch(getCollege(result)).then(updateForm);
              }}
            />
          </Label>
        </div>
      </div>
      {!isEmpty(institution._id) && (
        <Form initialValues={institution} setInstitution={setInstitution} />
      )}
    </>
  );
};

export default CollegeCampusForm;
